import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DEFAULT_TEETH, Tooth, ToothSide } from '@libs/ui-lib';
import { TeethComponent } from '@libs/perio';
import { TranslatePipe } from '@ngx-translate/core';

export const VIEW_WIDTH = 80.7;
export const UPPER_JAW_VIEW_HEIGHT = 197;
export const LOWER_JAW_VIEW_HEIGHT = 190;

@Component({
  selector: 'lib-perio-exam-tooth',
  templateUrl: 'perio-exam-tooth.component.html',
  styleUrls: ['./perio-exam-tooth.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TeethComponent, TranslatePipe],
})
export class PerioExamToothComponent {
  public readonly tooth = input.required<Tooth>();
  public readonly teeth = input.required<Tooth[]>();
  public readonly isToothMissing = input(false);
  public readonly toothOnly = input(false);
  public readonly isPerioHistoryView = input(false);
  public readonly activeSide = input.required<ToothSide>();

  protected readonly viewWidth = VIEW_WIDTH;
  protected readonly upperJawViewHeight = UPPER_JAW_VIEW_HEIGHT;
  protected readonly lowerJawViewHeight = LOWER_JAW_VIEW_HEIGHT;

  public displayedTeeth = computed(() => {
    return DEFAULT_TEETH.map((tooth) => {
      if (tooth.position === this.tooth().position) {
        return {
          ...this.tooth(),
        };
      }
      return tooth;
    });
  });
}
